import getCanvas from '../helpers/getCanvas';

const linkSubmitToButton = (html) => {
  const canvas = getCanvas(html);
  const link = canvas.querySelector('a[type="submit"]');
  const button = document.createElement('button');

  if (!link) {
    return html;
  }

  button.setAttribute('type', 'submit');
  button.innerHTML = link.textContent;

  link.insertAdjacentHTML('afterEnd', button.outerHTML);
  link.remove();

  return canvas.innerHTML;
};

export default linkSubmitToButton;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/factories/linkSubmitToButton.js
 **/